import axios from "./axios";
import { GET_PRODUCT_MERCHANT } from "./APILinks";


export const fetchProducts = async (merchantId) => {
  try {
    // eslint-disable-next-line
    const response = await axios.get(GET_PRODUCT_MERCHANT, {
      params: {
        merchant_id: merchantId,
      },
    });

    return response;

  } catch (error) {
    // Handle errors
    console.error("Error fetching product:", error);
  }
};